import React, {useState, useEffect, useContext} from 'react';
import {useParams} from "react-router";
import KanbanContent from "../../components/kanban/kanbanContent";
import {ListContext} from "../../context/ListContext";
import {APIGetContractedOrders} from "../../api/orders/Orders";
import {UserContext} from "../../context/UserContext";

export const OrdersManagementIndex = (data) => {
    const { user } = useContext(UserContext);
    const {type} = useParams();
    const [list, setList] = useState([]);
    const [settings, setSettings] = useState({
        all: {
            type:"ordersManagement",
            title:"Auftragsmanagement",
            creationLabel:"Auftrag erstellen",
            creationType:"order",
            filterAllows:false,
            search:{
                searchAllows:true,
                text:"Bezeichnung oder Auftrags-Nummer",
            },
            uploadPlanAllows:false,
            actions:{
                orderCreation:false,
                planCreation:false,
                planDelete:false,
                planCertificatedCreate:false,
                planOrderChange:false,
                planAddToMap:false,
                planLinkViewer:false,
                mapCreation:false,
                mapDelete:false,
                mapViewer:false,
            },
            kanbanColumnsCount:4,
            kanbanColumns: [
                {
                    "name":"Neue Aufträge",
                    "stage":"contracted",
                    "items":[]
                },
                {
                    "name":"In Bearbeitung",
                    "stage":"inDevelopment",
                    "items":[]
                },
                {
                    "name":"Zur Abnahme",
                    "stage":"inReview",
                    "items":[]
                },
                {
                    "name":"Abgeschlossen",
                    "stage":"completed",
                    "items":[]
                }
            ]
        }
    });

    useEffect(() =>
    {
        APIGetContractedOrders("contracted", user.companyId)
            .then((data) => {
                const newSetting = {...settings};
                let totalValue = 0;

                if(typeof data !== "undefined" && data !== null && data?.length > 0) {
                    for(const a of data) {
                        if(typeof a?.price !== "undefined" && Number(a?.price) > 0 ) {
                            totalValue = totalValue + Number(a?.price);
                        }
                    }
                }

                newSetting["all"]["kanbanColumns"][0]["items"] = (data !== null) ?  data : [];
                newSetting["all"]["kanbanColumns"][0]["totalValue"] = totalValue;
                setSettings(newSetting);
                }
            );
        APIGetContractedOrders("inDevelopment", user.companyId)
            .then((data) => {
                const newSetting = {...settings};
                let totalValue = 0;

                if(typeof data !== "undefined" && data !== null && data?.length > 0) {
                    for(const a of data) {
                        if(typeof a?.price !== "undefined" && Number(a?.price) > 0 ) {
                            totalValue = totalValue + Number(a?.price);
                        }
                    }
                }

                newSetting["all"]["kanbanColumns"][1]["items"] = (data !== null) ?  data : [];
                newSetting["all"]["kanbanColumns"][1]["totalValue"] = totalValue;
                setSettings(newSetting);
                }
            );
        APIGetContractedOrders("inReview", user.companyId)
            .then((data) => {
                const newSetting = {...settings};
                let totalValue = 0;

                if(typeof data !== "undefined" && data !== null && data?.length > 0) {
                    for(const a of data) {
                        if(typeof a?.price !== "undefined" && Number(a?.price) > 0 ) {
                            totalValue = totalValue + Number(a?.price);
                        }
                    }
                }

                newSetting["all"]["kanbanColumns"][2]["items"] = (data !== null) ?  data : [];
                newSetting["all"]["kanbanColumns"][2]["totalValue"] = totalValue;
                setSettings(newSetting);
                }
            );
        APIGetContractedOrders("completed", user.companyId)
            .then((data) => {
                const newSetting = {...settings};
                let totalValue = 0;

                if(typeof data !== "undefined" && data !== null && data?.length > 0) {
                    for(const a of data) {
                        if(typeof a?.price !== "undefined" && Number(a?.price) > 0 ) {
                            totalValue = totalValue + Number(a?.price);
                        }
                    }
                }

                newSetting["all"]["kanbanColumns"][3]["items"] = (data !== null) ?  data : [];
                newSetting["all"]["kanbanColumns"][3]["totalValue"] = totalValue;
                setSettings(newSetting);
                }
            );

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    var currentSetting = settings?.[(typeof type !== "undefined")? type : "all"];

    return (
        <div>
            <div className={"mx-auto max-w-7xl "}>
                <main>
                    <div className="w-full flex">
                        <ListContext.Provider value={{list,setList, type,currentSetting}}>
                            <KanbanContent/>
                        </ListContext.Provider>
                    </div>
                </main>
            </div>
        </div>
    )

}
